import * as React from 'react';

import { trackEstimHistoryItemDelete, trackRedirectToValReport } from '../../analytics';
import { PrevEstimations, IPrevEstimationsProps } from '../../components/PrevEstimations';
import { ShowMoreBtn } from '../../components/PrevEstimations/ShowMoreBtn';
import {
  useEstimationHistoryQuery,
  useDeleteEstimationHistoryItemQuery,
  checkHasData,
} from '../../serverState/estimationHistory';

export type TPrevEstimationsContainerProps = Pick<IPrevEstimationsProps, 'textColor'>;

export const PrevEstimationsContainer: React.VFC<TPrevEstimationsContainerProps> = (...props) => {
  const { data, hasNextPage, fetchNextPage, isFetching, isError } = useEstimationHistoryQuery();
  const { deleteEstimation, deleteInProgressId } = useDeleteEstimationHistoryItemQuery();

  const handleClickDeleteEstimation = React.useCallback(
    (id: number, url: string) => {
      deleteEstimation(id);
      trackEstimHistoryItemDelete(url);
    },
    [deleteEstimation],
  );

  if (!checkHasData(data)) {
    return null;
  }

  const showPreloader = isFetching || Boolean(deleteInProgressId);

  return (
    <PrevEstimations
      {...props}
      estimationHistory={data.pages}
      onEstimationDelete={handleClickDeleteEstimation}
      onRedirectToReportClick={trackRedirectToValReport}
      deleteInProgressId={deleteInProgressId}
      showMore={
        hasNextPage && (
          <ShowMoreBtn isLoading={showPreloader} onClick={fetchNextPage} disabled={showPreloader} isError={isError} />
        )
      }
    />
  );
};
